module.exports = __webpack_public_path__ + "img/dy_4.efaa9c50.png";